/* SpiceQuest site search analytics -> GA4 (G-LC1470GP8X).
   Events: sq_search_open, search (search_term), view_search_results (counts), search_no_results, select_search_result, sq_search_submit */
(function () {
  function send(name, params) {
    params = params || {};
    params.send_to = 'G-LC1470GP8X';
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
    else { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, params)); }
  }
  var lastTerm = '', lastReported = '', timer = null;
  function count(root, kind) { return root.querySelectorAll('li[id*="predictive-search-option-' + kind + '-"]').length; }
  function uniqCount(root, kind) { // desktop + mobile lists are both in the DOM; count one list
    var d = root.querySelectorAll('li[id*="predictive-search-option-' + kind + '-desktop-"]').length;
    var m = root.querySelectorAll('li[id*="predictive-search-option-' + kind + '-mobile-"]').length;
    return Math.max(d, m, d || m ? 0 : count(root, kind));
  }
  function report(ps) {
    var term = (ps.querySelector('input[type="search"]') || {}).value || '';
    term = term.trim(); if (!term || term === lastReported) return;
    var res = ps.querySelector('#predictive-search-results'); if (!res) return;
    var p = uniqCount(res, 'product'), a = uniqCount(res, 'article'), g = uniqCount(res, 'page'), c = uniqCount(res, 'collection'), q = uniqCount(res, 'query');
    lastReported = term;
    send('search', { search_term: term, source: 'predictive' });
    send('view_search_results', { search_term: term, products: p, articles: a, pages: g, collections: c, suggestions: q, total: p + a + g + c });
    if (p + a + g + c === 0) send('search_no_results', { search_term: term });
  }
  function wire(ps) {
    if (ps.__sq) return; ps.__sq = true;
    var input = ps.querySelector('input[type="search"]');
    if (input) input.addEventListener('input', function () { lastTerm = input.value.trim(); });
    new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(function () { report(ps); }, 700); })
      .observe(ps, { childList: true, subtree: true });
    ps.addEventListener('click', function (e) {
      var a = e.target.closest('a.predictive-search__item'); if (!a) return;
      var li = a.closest('li'); var id = (li && li.id) || '';
      var m = id.match(/predictive-search-option-(\w+)-(?:desktop-|mobile-)?(\d+)/);
      send('select_search_result', { search_term: lastTerm, result_type: m ? m[1] : 'unknown', position: m ? +m[2] : 0, result_title: (a.textContent || '').trim().slice(0, 80), result_url: a.getAttribute('href') });
    }, true);
    var form = ps.querySelector('form');
    if (form) form.addEventListener('submit', function () { send('sq_search_submit', { search_term: lastTerm }); });
  }
  function init() {
    document.querySelectorAll('predictive-search, search-form').forEach(wire);
    document.querySelectorAll('details-modal.header__search details').forEach(function (d) {
      if (d.__sq) return; d.__sq = true;
      d.addEventListener('toggle', function () { if (d.open) { lastReported = ''; send('sq_search_open', { page: location.pathname }); } });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
